const flopCards = [
  '"Weiß" immer alles besser',
  'Ändert die Meinung wie ein Fähnchen im Wind',
  'Besteht auf Jogginganzug als Berufskleidung',
  'Hält sich für einen Vampir',
  'Hat ein unseriöses Auftreten',
  'Hat eine Hausstauballergie',
  'Hat eine Pieps-Stimme',
  'Hat eine Rechts-Links-Schwäche',
  'Hat eine Sauklaue',
  'Hat eine Sonnenallergie',
  'Hat einen Hauptschulabschluss',
  'Hat einen IQ von 70',
  'Hat Höhenangst',
  'Hat immer einen Papagei auf seiner Schulter sitzen',
  'Hat keine Tischmanieren',
  'Hat keinen Führerschein',
  'Hat Klaustrophobie',
  'Hat permanent Mundgeruch',
  'Ist abergläubisch',
  'Ist alkoholabhängig',
  'Ist alleinerziehend mit drei kleinen Kindern',
  'Ist ängstlich',
  'Ist blind',
  'Ist cholerisch',
  'Ist detailverliebt',
  'Ist diskussionsfreudig',
  'Ist egoistisch',
  'Ist ein Langschläfer',
  'Ist ein Partylöwe',
  'Ist Einzelgänger/in',
  'Ist emotional',
  'Ist farbenblind',
  'Ist faul',
  'Ist Fernsehsüchtig',
  'Ist gehörlos',
  'Ist gewaltbereit',
  'Ist hoch verschuldet',
  'Ist hyperaktiv',
  'Ist immer zu stark parfümiert',
  'Ist introvertiert',
  'Ist Kettenraucher',
  'Ist Kleptomane',
  'Ist kontaktscheu',
  'Ist kreativ in der  Rechtsauslegung',
  'Ist langweilig',
  'Ist ortsgebunden',
  'Ist perfektionistisch',
  'Ist permanent Stress-gefährdet',
  'Ist pessimistisch',
  'Ist rassistisch',
  'Ist schüchtern',
  'Ist schwach',
  'Ist sehr tollpatschig',
  'Ist sexistisch',
  'Ist sexsüchtig',
  'Ist ständig schlecht gelaunt',
  'Ist stumm',
  'Ist ungeduldig',
  'Ist unhöflich',
  'Ist unkonzentriert',
  'Ist unpünktlich',
  'Ist unsportlich',
  'Ist vergesslich',
  'Ist vorbestraft',
  'Ist wasserscheu',
  'Ist zittrig',
  'Kann nichts schweres heben',
  'Kann nur halbtags arbeiten',
  'Kann nur per Home Office arbeiten',
  'Kennt Harry Potter auswendig',
  'Kommt einem beim Reden zu nah',
  'Lässt andere nicht ausreden',
  'Lästert gerne und viel',
  'Leidet unter Verfolgungswahn',
  'Lispelt',
  'Lügt notorisch',
  'Muss seinen Schmusehasen immer dabei haben',
  'Muss ständig niesen',
  'Nuschelt',
  'Redet nur über seinen/ihren Anwalt',
  'Schmatzt',
  'Spricht nur bayerisch',
  'Spricht nur in Reimen',
  'Stinkt',
  'Summt permanent vor sich hin',
  'Trägt einen Aluhut gegen Handystrahlung',
  'Wählt die AFD aus Überzeugung',
  'Wird schnell seekrank',
  'Wohnt noch bei Mama',
  'Hat eine unleserliche Schrift',
  'Kann nicht mit Geld umgehen',
  'Spielt gerne Streiche',
  'Lacht in unpassenden Momenten',
  'Muss unerkannt bleiben',
  'Ist nicht multitaskingfähig',
  'Hat einen imaginären Freund',
]

export { flopCards }
